import { createWorkbook, createWorksheet, exportWorkbook, setColumnWidths, styleColumns } from "../../ExportTemplateExcel/helperTemplateExcel";
import * as ExcelJS from 'exceljs';
import { LogExportExcel } from '../../../interfaces/Log';
import { currencyFormatter, sanitizeTagHtml } from "../../general";
import { SettingMultiPipelines } from "../../../interfaces/Settings";

interface ExportExcelLogProps {
    source: string;
    nameFile: string;
    nameHeader: any;
    data: LogExportExcel[];
    selectMultiPipeline: SettingMultiPipelines;
}

export const exportExcelLog = ({ source, nameFile, nameHeader, data, selectMultiPipeline }: ExportExcelLogProps) => {
    let exportData: any[] = [];
    const workbook = createWorkbook();
    const worksheet = createWorksheet(workbook, source);

    let header = nameHeader.header;
    let subHeader = nameHeader.subHeader;
    data.flat().forEach((row) => {
        let temp_excel = [
            row.merchantName,
            row.picName,
            row.age,
            currencyFormatter(row.nominal, selectMultiPipeline.currencyIsRounded, selectMultiPipeline.currencyCode, { showPrefix: true }),
            row.source,
            row.createdBy,
            row.dateStart,
            row.duration,
            row.progressName + `${row.subProgress ? ` (${row.subProgress})` : ''}`,
            sanitizeTagHtml(row.description),
            row.files,
        ]
        exportData.push(temp_excel)
    })

    worksheet.getRow(1).values = header
    worksheet.getRow(2).values = subHeader

    addDataRows(worksheet, exportData)
    setColumnWidths(worksheet, source, header)
    styleColumns(worksheet, source, 1)
    styleColumns(worksheet, source, 2)

    exportWorkbook(workbook, `${nameFile}.xlsx`);
}

const addDataRows = (
    worksheet: ExcelJS.Worksheet,
    data: any[],
) => {
    data.forEach((rowData) => {
        worksheet.addRow(rowData);
    })
}